import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'query-string';

const useCategoryListRouter = (initOptions) => {
  const { filterOption, pagination } = initOptions;
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const routeByFilterOption = (filterOption) => {
    const queryString = qs.stringify(filterOption, { skipNull: true });
    navigate(`${pathname}?${queryString}`);
  };

  const routeEvent = useCallback(
    (param) => {
      const options = {
        filterOption,
        pagination,
        ...param,
      };

      const query = {
        ...options.filterOption,
        pageSize: options.pagination.pageSize,
        page: options.pagination.pageNum + 1,
      };

      routeByFilterOption(query);
    },
    [navigate, pathname, filterOption, pagination],
  );

  return { routeByFilterOption, routeEvent };
};

export default useCategoryListRouter;
